import React from 'react';
import { Td, Th, Tr } from '../../../../shared/Table';
import {
  DataForDesignDrawingsManifold,
  DataForDesignDrawingsRoom,
} from '../../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';

type RoomRowProps = {
  name: string;
  manifold: DataForDesignDrawingsManifold;
  getValue: (room: DataForDesignDrawingsRoom) => string | number | null;
};

export const RoomRow = ({ name, manifold, getValue }: RoomRowProps) => (
  <Tr>
    <Th scope="row">{name}</Th>
    {manifold.rooms.map(
      room =>
        room.numberOfPorts > 0 && (
          <Td key={room.roomId} colSpan={room.numberOfPorts}>
            {getValue(room)}
          </Td>
        ),
    )}
  </Tr>
);

export const getThermostatName = (room: DataForDesignDrawingsRoom) => {
  if (room.thermostatTypeName === 'Shared' && room.thermostatSharedWithRoomName) {
    return `Shared with ${room.thermostatSharedWithRoomName}`;
  }
  return room.thermostatTypeName;
};
